import { useState, useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import { logoutUser } from "../Redux/userSlice";
import useUser from "./useUser";

const useAxios = () => {
	const {  Authorization } = useSelector((state) => state.user);

	const dispatch = useDispatch();
	// const { Authorization } = useUser();
	const [response, setResponse] = useState([]);
	const [responseAllData, setResponseAllData] = useState([]);
	const [totalCount, setTotalCount] = useState(0);
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const [controller, setController] = useState();
	const [initialResponse, setInitialResponse] = useState(null);
	

	const axiosFetch = async (config) => {
		const {
			axiosInstance,
			method,
			url,
			requestConfig = {}
		} = config;

		// console.log('test requestConfig',requestConfig)

		try {

			setLoading(true);
			const ctrl = new AbortController();
			setController(ctrl);

			// Adding Authorization key into the request headers
			if (requestConfig?.headers !== undefined) {
				requestConfig.headers = {
					...requestConfig.headers,
					'Authorization': `Bearer ${Authorization}`
					
				}
			
				
			} else {
				requestConfig.headers = {
					'Authorization': `Bearer ${Authorization}`

				};
			}

			let res;
			if (method.toLowerCase() === 'post' || method.toLowerCase() === 'put') {
				res = await axiosInstance[method.toLowerCase()](url, requestConfig.data, {
					headers: requestConfig.headers,
					signal: ctrl.signal
				});
			} else {
				res = await axiosInstance[method.toLowerCase()](url, {
					...requestConfig,
					signal: ctrl.signal
				});
			}

			// Checking Unauthorized User Access & Logging out user.
			if (res.status === 401) {
				dispatch(logoutUser());
			} else {

				const response = res.data;
				if(res.status)
				{
					setInitialResponse(response);
				}else{
					setInitialResponse(null);

				}


				if (res.status) {
					let tempRes = [];
					let allRes = [];
					let totalCount = 0;
					// if (response?.response !== undefined && response.response?.result !== undefined) {
						if (res?.data !== undefined && res.data != null) {
							tempRes = res.data;
							// totalCount = response.response.result.count;
						}
						else {
							tempRes = res.data;
						}
						allRes = res.data;


					if (!Array.isArray(tempRes)) {
						tempRes = [tempRes];
					}
					console.log("test resp",response)

					setError(response?.message);
					setResponse(tempRes);
					// setTotalCount(totalCount);
					setResponseAllData(allRes)
				} else {
					let resErrors = res?.status;

					
					if (res !== undefined && res?.error !== undefined) {
						resErrors = res.error;
					}
					setError(resErrors?resErrors:res?.message);
				}
			}
		} catch (err) {
			console.log("test catch AXIOS Error: ", err);
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		return () => controller && controller.abort();
	}, [controller]);

	// return [response, error, loading, axiosFetch, totalCount, responseAllData,initialResponse];
	return [response, error, loading, axiosFetch, responseAllData,initialResponse];
}

export default useAxios;